import { getDistributor } from '../../../api/distributors';
import { BAD_LOAD, GET_DISTRIBUTOR_LOADING, GET_DISTRIBUTOR } from '../constants';
export default {
  async getDistributor({ commit, state }) {
    try {
      if (state.item || state.loading) return;
      commit(GET_DISTRIBUTOR_LOADING, true);
      const data = await getDistributor();
      commit(GET_DISTRIBUTOR, data.data);
    } catch (e) {
      commit(BAD_LOAD, e.data ? e.data.message : e.message || e, { root: true });
    } finally {
      commit(GET_DISTRIBUTOR_LOADING, false);
    }
  }
};
